export default __webpack_public_path__ + "static/media/jack-miller-qa-wide.2019fd0a.jpg";